import { Link } from "react-router-dom";

export default function ContractTable({
    loading,
    data,
    currentPage,
    perPage,
    selectedRows,
    userRole,
    viewType
}) {

    const startIdx = (currentPage - 1) * perPage;
    const allSelected = data.every((_, i) => selectedRows[startIdx + i]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? "-" : date.toLocaleDateString("en-GB");
    };

    return (
        <div className="table-responsive border">
            <table className="table align-middle mb-0">
                <thead className="bg-light">
                    <tr>
                        <th className="border">ID</th>
                        <th className="border">Buyer</th>
                        <th className="border">Seller</th>
                        <th className="border">Creation Date</th>
                        <th className="border">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={3} className="text-center py-3">
                                Loading...
                            </td>
                        </tr>
                    ) : data.length > 0 ? (
                        data.map((item, index) => {
                            const globalIndex = startIdx + index;
                            return (
                                <tr key={globalIndex}>
                                    <td className="fw-semibold border text-primary">
                                        <Link
                                            to={userRole === 'Admin' ? `/admin-dashboard/communication/${item._id}` : `/manager-dashboard/communication/${item._id}`}
                                            className="text-black underline"
                                        >
                                            {viewType === 'contracts' ? item.groupId.replace(/^PRG-/, 'CRT-') : item.groupId}
                                        </Link>
                                    </td>
                                    <td className="border">
                                        {item.buyerCompanyName || "-"}
                                    </td>
                                    <td className="border">
                                        {item.companyName || "-"}
                                    </td>
                                    <td >
                                        {formatDate(item.createdAt) || "-"}
                                    </td>
                                    <td className="fw-semibold border text-primary">
                                        <div
                                            className="btn fw-semibold"
                                            style={{
                                                backgroundColor: "#F8F5FF",
                                                color: "#5014D0",
                                                borderRadius: "20px",
                                                padding: "4px 12px",
                                                fontSize: "0.85rem",
                                            }}
                                        >
                                            {item.status || "-"}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={3} className="text-center text-muted py-3">
                                No Contract found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
